import React, {useEffect} from 'react';
import logo from '../logo.png';
import { Button } from 'antd';
import { PlayCircleOutlined, SecurityScanOutlined } from "@ant-design/icons";
import { gsap } from "gsap";
const Hero = () => {
    useEffect(() => {
        gsap.from('.logoHero', {opacity: 0, scale: 0.5, duration: 1})
        gsap.from('.svgHero2', {delay: 1, y: -20})
    }, [])
    return(
        <div className='hero'>
            <div className='heroSection'>
                <div className='logoSection'>
                    <img className='logoHero' src={logo}/>
                </div>
                <div className='heroBtns'>
                    <Button icon={<PlayCircleOutlined />} href='#video' className='heroBtn' size="large" type="primary">Zobacz filmik</Button>
                    <Button icon={<SecurityScanOutlined />} href='#why-us' className='heroBtn' size="large" type="primary">Dlaczego nasza szkoła?</Button>
                </div>
            </div>
            <svg className='svgHero1' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path fill="#0e0f40" fill-opacity="1" d="M0,96L34.3,128C68.6,160,137,224,206,229.3C274.3,235,343,181,411,138.7C480,96,549,64,617,64C685.7,64,754,96,823,138.7C891.4,181,960,235,1029,250.7C1097.1,267,1166,245,1234,229.3C1302.9,213,1371,203,1406,197.3L1440,192L1440,0L1405.7,0C1371.4,0,1303,0,1234,0C1165.7,0,1097,0,1029,0C960,0,891,0,823,0C754.3,0,686,0,617,0C548.6,0,480,0,411,0C342.9,0,274,0,206,0C137.1,0,69,0,34,0L0,0Z"></path>
            </svg>
            <svg className='svgHero2' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ff5500" fill-opacity="1" d="M0,96L34.3,128C68.6,160,137,224,206,229.3C274.3,235,343,181,411,138.7C480,96,549,64,617,64C685.7,64,754,96,823,138.7C891.4,181,960,235,1029,250.7C1097.1,267,1166,245,1234,229.3C1302.9,213,1371,203,1406,197.3L1440,192L1440,0L1405.7,0C1371.4,0,1303,0,1234,0C1165.7,0,1097,0,1029,0C960,0,891,0,823,0C754.3,0,686,0,617,0C548.6,0,480,0,411,0C342.9,0,274,0,206,0C137.1,0,69,0,34,0L0,0Z"></path></svg>
        </div>
    )
}
export default Hero;